// This is the entry point for the home component
/*eslint-disable */
//Strange prettier error and multiple Must use destructuring props assignment errors
import React, { FC, useContext, useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { toastMessage } from 'Containers/Toast/actions';
import { modalShow } from 'Containers/Modal/actions';
//import SelectList from "Components/SmartList";
import TableHeader from 'Components/Headers/TableHeader';
import UserDetailsContext from 'Context/userDetailsContext';
// eslint-disable-next-line import/no-extraneous-dependencies
import { useMutation, useLazyQuery } from '@apollo/react-hooks';
import {
  deleteLeadsGql,
  duplicateListGql,
  exportListGql,
  exportListAudienceMembersGql,
} from './gqlQuery';
import SmartList from 'Components/SmartList';
import { useHistory } from 'Utils/router';
import { removeLeads } from '../../AudienceExplore/actions/individuallist.actions';
import { exportList } from '../../../downloadFile';
import { loadFilterStateFromAttributes } from 'Containers/Filter/actions/filter.actions';
import { useRouter } from 'Utils/router';
import { ProductAnalyticsContext } from 'Context/ProductAnalytics';
import withErrorBoundary from 'HOC/ErrorBoundary';

interface Props {
  onSearch?: (search: string) => void;
  startDate: string;
  endDate: string;
  headerTitle: string;
  audienceTotal: number;
  checkedBoxCount: number;
  listName?: string;
  listId?: string;
  checkedItems?: any;
  userIds: any;
  filters?: any;
  setRefreshList: (val: any) => void;
  userKeys: string[];
  items?: any;
  loadAttributes?: any;
  sort?: any;
  searchText?: string;
}

const AudienceTableHeaderContainer: FC<Props> = (props: any) => {
  const Dispatch = useDispatch();
  const userDetails = useContext(UserDetailsContext);
  const history = useHistory();
  const {
    helpers: { View },
    actions: { track },
  } = useContext(ProductAnalyticsContext);
  const { location } = useRouter();

  const [duplicateList, { loading: dupLoading }] = useMutation(
    duplicateListGql,
    {
      onCompleted: (data: any) => {
        Dispatch(
          toastMessage({
            message: `<i>${data.listDuplicate.data.name}</i> has been created successfully`,
            position: 'bottom',
          })
        );
      },
    }
  );

  const onMenuChange = (event: any) => {
    switch (event.target.label.toLowerCase()) {
      case 'duplicate':
        if (dupLoading) return;
        duplicateList({
          variables: {
            inst_id: userDetails.instId,
            account_id: userDetails.accountId,
            name: `${props.listName} (copy)`,
            id: props.listId,
          },
        });
        break;
      case 'delete':
        Dispatch(
          modalShow({
            title: 'Delete List',
            visible: true,
            width: 560,
            titlePosition: 'center',
            children: (
              <SmartList.Delete
                id={props.listId}
                listName={props.listName}
                redirect={true}
              ></SmartList.Delete>
            ),
          })
        );
        break;
      case 'rename':
        Dispatch(
          modalShow({
            title: 'Rename Inquiry List',
            visible: true,
            width: 640,
            titlePosition: 'center',
            children: (
              <SmartList.Edit
                count={props.audienceTotal}
                id={props.listId}
                redirect={true}
              ></SmartList.Edit>
            ),
          })
        );
        break;
      case 'permissions':
        Dispatch(
          modalShow({
            title: 'List Permissions',
            visible: true,
            width: 560,
            titlePosition: 'center',
            children: (
              <SmartList.Permissions id={props.listId}></SmartList.Permissions>
            ),
          })
        );
        break;
      case 'load attributes in explore':
        loadFilterStateFromAttributes(Dispatch, props.loadAttributes);

        //Redirect to the leads/explore page
        history.push('/inquiries/explore');
        break;
      default:
        break;
    }
  };

  const [deleteLeads] = useMutation(deleteLeadsGql, {
    variables: {
      inst_id: userDetails.instId,
      account_id: userDetails.accountId,
      id: props.listId,
      user_ids: props.userIds,
    },
    onCompleted: () => {
      Dispatch(
        removeLeads({
          listId: props.listId,
          userKey: props.userKeys,
          userId: props.userIds,
        })
      );

      Dispatch(
        toastMessage({
          message: `Selected Inquiries have been removed from saved list`,
          position: 'bottom',
        })
      );

      props.setRefreshList(true);
    },
  });

  const [exportData] = useLazyQuery(exportListGql, {
    onCompleted: (data: any) => {
      exportList(data.link.downloadLink);
    },
    onError: (error: any) => {
      Dispatch(
        toastMessage({
          message: 'User is not authorized to download',
          position: 'bottom',
        })
      );
    },
    fetchPolicy: 'no-cache',
  });

  //This is used for the export in Lists->list
  const [exportListAudienceMembers] = useLazyQuery(
    exportListAudienceMembersGql,
    {
      onCompleted: (data: any) => {
        exportList(data.link.downloadLink);
      },
      onError: (error: any) => {
        Dispatch(
          toastMessage({
            message: 'User is not authorized to download',
            position: 'bottom',
          })
        );
      },
      fetchPolicy: 'no-cache',
    }
  );
  const exportToExcelLists = useCallback(() => {
    Dispatch(
      toastMessage({
        message: 'Generating Excel file…',
        position: 'bottom',
      })
    );

    //Prod keeps chaning their mind.  Originally it was all sorted by Major:asc
    //Then it was to be sorted based on the user sort of the data.
    //Now it's back to being sorted by one column only.
    //I would keep this in place, in case they change their mind again.
    //If sort is name, then it needs to be changed
    //const excellSort = props.sort.split(":");
    // const sort =
    //     excellSort[0] === "name"
    //       ? `firstName:${excellSort[1]},lastName:${excellSort[1]}`
    //       : props.sort,
    const variables = {
      inst_id: userDetails.instId,
      account_id: userDetails.accountId,
      id: props.listId || '',
      sort: 'dateRegistered:DESC',
      search: props.searchText || '',
    };

    exportListAudienceMembers({ variables });
  }, [
    props.userIds,
    props.sort,
    props.filters.listMembership,
    props.filters,
    props.searchText,
    props.listId,
  ]);

  const exportToExcel = useCallback(() => {
    Dispatch(
      toastMessage({
        message: 'Generating Excel file…',
        position: 'bottom',
      })
    );

    //Prod keeps chaning their mind.  Originally it was all sorted by Major:asc
    //Then it was to be sorted based on the user sort of the data.
    //Now it's back to being sorted by one column only.
    //I would keep this in place, in case they change their mind again.
    //If sort is name, then it needs to be changed
    // const excellSort = props.sort.split(":");
    // const sort =
    //     excellSort[0] === "name"
    //       ? `firstName:${excellSort[1]},lastName:${excellSort[1]}`
    //       : props.sort,
    const variables = {
      inst_id: userDetails.instId,
      sort: 'dateRegistered:DESC',
      user_ids: props.userIds,
      listMemberShip: props.filters.listMembership,
      search: props.searchText || '',
    };

    //If the userIds are empty, then add the filtersv2 property
    if (!props.userIds.length) variables['filtersv2'] = props.filters.filtersv2;

    exportData({ variables });
  }, [props.userIds, props.filters.listMembership, props.sort, props.filters]);

  const exportClick = () => {
    const pathName = location.pathname;
    const userIdsLength = props.userIds.length;
    const useSelectedUsers = userIdsLength > 0;

    // Combined Analytics event tracking
    track('audiences_exported', {
      screen: View(pathName),
      scope: useSelectedUsers ? 'Selected' : 'All',
      audience_count: useSelectedUsers ? userIdsLength : props.audienceTotal,
    });
    //Get the route and determine if it's from Explore or Inquiries

    //Need to pass where this is calling from to the props.exportButtonClicked method
    if (pathName.startsWith('/inquiries/explore')) {
      exportToExcel();
    } else if (pathName.startsWith('/inquiries/lists')) {
      if (props.userIds.length) exportToExcel();
      //otherwise, call exportToExcelLists
      else exportToExcelLists();
    }
  };

  return (
    <>
      <TableHeader
        onSearch={props.onSearch}
        audienceTotal={props.audienceTotal}
        checkedBoxCount={props.checkedBoxCount}
        listName={props.listName}
        onMenuChange={onMenuChange}
        items={props.items}
        addToListClicked={() => {
          Dispatch(
            modalShow({
              title: 'Add to List',
              visible: true,
              width: 850,
              titlePosition: 'center',
              children: (
                <SmartList.Select
                  checkedItems={props.checkedItems}
                  userIds={props.userIds}
                  filters={props.filters}
                  openDefault={'existing'}
                  fromListId={props.listId}
                  searchText={props.searchText}
                />
              ),
            })
          );
        }}
        removeFromListClicked={() => {
          deleteLeads();
        }}
        exportButtonClicked={exportClick}
      />
    </>
  );
};
export default withErrorBoundary(AudienceTableHeaderContainer);
